var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"novel_generator"}},[_c('top'),_c('div',{staticClass:"mian",style:({ height: _vm.mianH + 'px' })},[_c('generatorLeft',{on:{"openContent":_vm.openContent}}),(_vm.histroyShow)?_c('generatorHistroy'):_c('generatorContent'),_c('generatorResult',{on:{"openHistroy":_vm.openHistroy}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }